import React from 'react';
import clsx from 'clsx';
import { ctaPurpleRight } from '../../../../../../../assets/hostedassets';
import profileStyles from './UserProfile.module.scss';
import tabStyles from '../../../../ManagementProfileTab/ManagementProfileTab.module.scss';
import type { CreditBureauRowProps } from './ManagementUserProfile.types';
import { hasValidCreditScore } from './managementUserProfileUtils';
import DrawerRow from './DrawerRow';
import ClickableValue from './ClickableValue';

const CreditBureauRow = ({ score, onClick, isPDFReport }: CreditBureauRowProps) => {
    const clickable = hasValidCreditScore(score) && !isPDFReport && !!onClick;
    return (
        <DrawerRow
            label="Credit Bureau"
            valueOwnsStyling
            value={
                hasValidCreditScore(score) ? (
                    <ClickableValue
                        clickable={clickable}
                        onClick={onClick}
                        className={clsx(profileStyles.CountValue, { [tabStyles.creditClickable]: clickable })}
                    >
                        <span className={tabStyles.creditScore}>
                            {!isPDFReport && <img src={ctaPurpleRight} alt={''} className={profileStyles.CountIcon} />}
                            {score}
                        </span>
                    </ClickableValue>
                ) : undefined
            }
        />
    );
};

export default CreditBureauRow;
